import React from 'react';
import { Box } from '@mui/material';
import { ActionButton } from './LMA.style';

interface ActionButtonsProps {
  primaryLabel: string;
  selectedCount: number;
  onPrimaryAction: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  primaryLabel,
  selectedCount,
  onPrimaryAction,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <ActionButton
        variant="contained"
        onClick={onPrimaryAction}
        disabled={selectedCount === 0}
        sx={{
          backgroundColor: (theme: any) => theme.palette.themeColor?.main,
          color: (theme: any) => theme.palette.white?.main,
          '&:hover': {
            opacity: 0.8,
            backgroundColor: (theme: any) => theme.palette.themeColor?.main,
          },
          '&.Mui-disabled': {
            backgroundColor: (theme: any) => theme.palette.neutral4?.main,
            color: (theme: any) => theme.palette.neutral6?.main,
          },
        }}
      >
        {primaryLabel} ({selectedCount})
      </ActionButton>
    </Box>
  );
};

export default ActionButtons;
